import React from 'react';
import { Box, Typography } from '@mui/material';

const LogoNavbar = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        component="img"
        src="/logoenpiso.jpg"
        alt="Icono de Balance"
        sx={{
          width: 80,
          maxWidth: '60%',
          height: 'auto',
          objectFit: 'contain',
          mb: 0,
        }}
      />

      <Typography
        component="h1"
        sx={{
          fontSize: '2em',
          fontWeight: 900,
          textAlign: 'center',
          margin: 0,
          textDecoration: 'none',
        }}
      >
        <Box component="span" sx={{ color: '#80B7AE' }}>En</Box>
        <Box component="span" sx={{ color: '#BCFF66' }}>Piso</Box>
      </Typography>
    </Box>
  );
};

export default LogoNavbar;